{
    "Advertisers": "Advertisers",
    "Advertiser": "Advertiser",
    "advertisers": "advertisers",
    "advertiser": "advertiser"
}
